import { forwardRef } from "react";
import {
  MenuItem as RACMenuItem,
  MenuItemProps as RACMenuItemProps,
  composeRenderProps,
} from "react-aria-components";
import { IconType } from "../../foundations/Icons/types";
import Icon from "../../foundations/Icons/Icon";
import { cn } from "../../cn";
import { styles } from "./styles";

interface MenuItemProps extends RACMenuItemProps {
  size?: "base" | "lg";
  leftIcon?: IconType;
  iconClassName?: string;
}

const MenuItem = forwardRef<HTMLDivElement, MenuItemProps>(
  ({ size = "base", leftIcon, iconClassName, ...props }, ref) => {
    return (
      <RACMenuItem
        {...props}
        ref={ref}
        className={composeRenderProps(
          props.className,
          (className, renderProps) =>
            styles({ ...renderProps, className, size }),
        )}
      >
        {composeRenderProps(props.children, (children) => {
          return (
            <>
              {leftIcon && (
                <Icon
                  icon={leftIcon}
                  className={cn("size-5 mr-3", iconClassName)}
                />
              )}
              {children}
            </>
          );
        })}
      </RACMenuItem>
    );
  },
);

MenuItem.displayName = "MenuItem";

export default MenuItem;
